import API from "../plugin/libs/axios";
import URL from '../plugin/config/url'
import addRouter from '@wd/cms-h5/addRouter'
const pako = require('pako');
function addErrorRouter(router) {
  let errorPage = [
    {
      path: '/401',
      name: 'error_401',
      component: () => import(/* webpackChunkName: 'error' */ '../plugin/view/error/401.vue'),
    },
    {
      path: '/500',
      name: 'error_500',
      component: () => import(/* webpackChunkName: 'error' */ '../plugin/view/error/500.vue'),
    },
    {
      path: '*',
      name: 'error_404',
      component: () => import(/* webpackChunkName: 'error' */ '../plugin/view/error/404.vue')
    },
  ]
  router.addRoutes(errorPage)
}

function Utf8ArrayToStr(array) {
  var out, i, len, c;
  var char2, char3;
  out = "";
  len = array.length;
  i = 0;
  while (i < len) {
    c = array[i++];
    switch (c >> 4) {
      case 0: case 1: case 2: case 3: case 4: case 5: case 6: case 7:
        // 0xxxxxxx
        out += String.fromCharCode(c);
        break;
      case 12: case 13:
        // 110x xxxx   10xx xxxx
        char2 = array[i++];
        out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));
        break;
      case 14:
        // 1110 xxxx  10xx xxxx  10xx xxxx
        char2 = array[i++];
        char3 = array[i++];
        out += String.fromCharCode(((c & 0x0F) << 12) |
            ((char2 & 0x3F) << 6) |
            ((char3 & 0x3F) << 0));
        break;
    }
  }
  console.log(JSON.parse(out));
  return JSON.parse(out)
}

function unzip(b64Data) {
  var strData = b64Data;
  var charData = strData.split('').map(function (x) { return x.charCodeAt(0); });
  var binData = new Uint8Array(charData);
  var data = pako.ungzip(binData);
  return Utf8ArrayToStr(data);
}


function getLayoutSetting(router, _this) {
  let base = require('js-base64').Base64;
  const port = window.location.port;
  const hostname = window.location.hostname
  const UrlName = '/modular/admin/v1'
  let confUrl = port ? base.encode(URL.TestDomain) : base.encode(hostname);
  return API({
    url: `${UrlName}/configurations/${confUrl}`,
    method: 'Get',
  })
      .then((data) => {
        _this.commit('setPageSetData', data.data);
        _this.commit('storePageEnd',JSON.stringify(data.data.pageEnd))
        _this.commit('storePageEndSettingStatus',JSON.stringify(data.data.pageEndSetting))
        _this.commit('storePageHeaderSettingStatus',JSON.stringify(data.data.pageHeaderSetting))
        _this.commit('frontendConfig', data.data.frontendConfig);
        _this.commit('pageTitle', data.data.websiteSetting.pageTitle);
        _this.commit('theme', data.data.theme);
        _this.commit('pageBackgroundSetting', JSON.stringify(data.data.pageBackgroundSetting))
        let temp = {
          pageHeader: data.data.pageHeader,
          pageHeaderSetting: data.data.pageHeaderSetting,
          pageEndSetting: data.data.pageEndSetting,
          pageEnd: data.data.pageEnd,
          pageUrlList:data.data.pageUrlList,
          solutionStatus: data.data.solutionStatus
        }

        if (data.data&&data.data.navagation&&data.data.navagation.bottomMenu) {
          const mineMenu = data.data.navagation.bottomMenu.find((m) => { return m.name === '我的' })
          if (mineMenu&&mineMenu.url) {
            sessionStorage.setItem('mineMenu', mineMenu.url)
            localStorage.setItem('mineMenu', mineMenu.url)
          }
        }

        localStorage.setItem('frontendConfig', JSON.stringify(data.data.frontendConfig)) //本地存储数据
        sessionStorage.setItem('frontendConfig', JSON.stringify(data.data.frontendConfig))

        localStorage.setItem('branchUcode', data.data.branchUcode?data.data.branchUcode:'')
        sessionStorage.setItem('branchUcode', data.data.branchUcode?data.data.branchUcode:'')


        localStorage.setItem('theme', data.data.theme || '');
        sessionStorage.setItem('theme', data.data.theme || '');


        if(data.data.pageEnd){
          sessionStorage.setItem('menuList', data.data.pageEnd.menuList?JSON.stringify(data.data.pageEnd.menuList):JSON.stringify('[]'))
          localStorage.setItem('menuList', data.data.pageEnd.menuList?JSON.stringify(data.data.pageEnd.menuList):JSON.stringify('[]'))
        }

        // 配置首页 存储
        let homepage = data.data.frontendConfig.filter(item => {
          if (item.key === 'homepage') {
            return true;
          }
        })

        sessionStorage.setItem('homepage', JSON.stringify(homepage))
        localStorage.setItem('homepage', JSON.stringify(homepage))


        localStorage.setItem('setTempConfigs', JSON.stringify(temp)) //本地存储数据
        localStorage.setItem('noticeMessage', JSON.stringify(data.data.noticeMessage)) //本地存储数据
        let branchId = data.data.branchId
        if (branchId == null || branchId == '-1') {
          branchId = data.data.solutionInfo.defaultBranchId
        }
        localStorage.setItem('branchId', branchId)
        localStorage.setItem('saasId', data.data.solutionInfo.rid)
      })
      .catch((error) => {
        console.log("error---", error);
      });

}


function getLayoutJson(router, _this) {
  let base = require('js-base64').Base64;
  const port = window.location.port;
  const hostname = window.location.hostname
  const UrlName = '/modular/admin/v1'
  let confUrl = port ? base.encode(URL.TestDomain) : base.encode(hostname);
  let search = window.location.search;
  let type = search.includes('preview')?'1':'';
  let apiUrl = type != '1'?`${UrlName}/pages/${confUrl}`:`${UrlName}/pages/${confUrl}?type=1`;
  return API({
    url:apiUrl,
    method: 'Get',
  }).then((data) => {
    if (data.code == "0") {
      // localStorage.setItem('setPageConfigs', JSON.stringify(data.data.dragList)) //本地存储数据
      let newData = unzip(data.data);
      newData.pages.map((page) => {
        if (page.uri) {
          const route = {
            path: page.uri.indexOf(':') != -1 ? page.uri.split(':')[0] : page.uri,
            name: page.pageName,
            query: page.uri.indexOf(':') != -1 ? page.uri.split(':')[1] : '',
            component: () => import(/* webpackChunkName: 'common' */ '../plugin/view/common/index.vue'),
            meta: {
              keepAlive: false,
              moduleId: page.pageName,
              name: page.label,
              noLogin: true
            },
          };
          router.addRoute(route);
          // if (window.location.pathname == page.manual_url || window.location.pathname == page.uri) {
          //   getShare({
          //     imgUrl: page.pageLogo || "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/c-mini/app_logo.png",
          //     title: page.pageTitle || '伟东云平台',
          //     desc: page.pageAbstract || '',
          //     link: `${window.location.href}`,
          //   })
          // }
        }

        if (page.manual_url) {
          const routes = {
            path: page.manual_url,
            name: page.pageName,
            query: '',
            component: () => import(/* webpackChunkName: 'common' */ '../plugin/view/common/index.vue'),
            meta: {
              keepAlive: false,
              moduleId: page.pageName,
              name: page.label,
              noLogin: true
            },
          };
          router.addRoute(routes);
        }
      });
      _this.commit('setPageConfigs', newData.pages);
      // resolve(router);

    } else {
      // reject(data.message);
    }
  })
      .catch((error) => {
        console.log("error---", error);
      });
}

function getShare(configObj) {
  const ourl = window.location.href.split('#')[0];
  var shlink = configObj.link || window.location.href.split('#')[0]
  API({
    url: `/common-services/v1/wx/getWeConfig`,
    method: 'Get',
    params: { url: ourl }
  }).then((res) => {
    if (res.success) {
      window.wx.config({
        debug: false,
        appId: res.data.appId,
        timestamp: res.data.timeStamp,
        nonceStr: res.data.nonce,
        signature: res.data.signature,
        jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'checkJsApi'],
        openTagList: ['wx-open-launch-app'],
      })

      window.wx.ready(function () {
        window.wx.checkJsApi({
          jsApiList: ['wx-open-launch-app', 'updateAppMessageShareData'],
          success: function (res) {
            console.log('可用')
          },
          fail: (err) => {
            console.log(err, '不可用')
          },
        })
        //分享朋友以及qq
        window.wx.updateAppMessageShareData({
          title: configObj.title, // 分享标题
          desc: configObj.desc, // 分享描述
          link: shlink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: configObj.imgUrl, // 分享图标
          success: function () {
            // 用户点击了分享后执行的回调函数
            console.log('成功')
            // $.post("$ctx/activity/shareCount.do",{"unionid":"$!unionid"},function(){});
          },
          complete() {
            console.log(434343);
          }
        })
        //分享朋友圈以及空间
        window.wx.updateTimelineShareData({
          title: configObj.title, // 分享标题
          link: shlink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: configObj.imgUrl, // 分享图标
          success: function () {
            // 用户点击了分享后执行的回调函数
            console.log('成功')
            // $.post("$ctx/activity/shareCount.do",{"unionid":"$!unionid"},function(){});
          },
        })
      })
    }
  })
}

let setLayoutToRouter = (router,_this) => {
  addRouter(router)
  return new Promise( async (resolve) => {
    await getLayoutJson(router, _this)
    await getLayoutSetting(router, _this)
    resolve(true)
  }).then((e) => {
    addErrorRouter(e)
  }).catch((error) => {
    console.log('error--->', error)
  })
}






let getSetPageConfigs =(_this)=>{
  return  _this.state.dynamic.pageConfigs;
}
let getPageEndSetting =(_this)=>{
  return _this.state.dynamic.pageEndSetting;
}
let getPageEnd =(_this)=>{
  return _this.state.dynamic.pageEnd;
}
let getPageBackgroundSetting =(_this)=>{
  return _this.state.dynamic.pageBackgroundSetting;
}
let getConfigruation =(_this)=>{
  return _this.$store.state.dynamic.pageSetData;
}

let getTheme =(_this)=>{
  return _this.state.dynamic.theme;
}

let getPageTitle =(_this)=>{
  return _this.state.dynamic.pageTitle;
}




export default {
  setLayoutToRouter,
  getSetPageConfigs,
  getPageEndSetting,
  getPageEnd,
  getConfigruation,
  getPageBackgroundSetting,
  getTheme,
  getPageTitle
}

